"use client";

import { useState } from "react";
import { ChevronDown, ChevronUp, HelpCircle } from "lucide-react";

interface FAQItemProps {
  question: string;
  answer: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`border transition-all duration-300 rounded-xl mb-3 ${isOpen ? "border-cyan-400/50 bg-white/5" : "border-gray-800 bg-transparent"
      }`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-5 text-left transition-colors"
      >
        <span className={`font-bold transition-colors ${isOpen ? "text-cyan-400" : "text-white"}`}>
          {question}
        </span>
        <div className={`p-1 rounded-full bg-white/5 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}>
          <ChevronDown className="text-cyan-400" size={18} />
        </div>
      </button>
      <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}>
        <div className="overflow-hidden">
          <p className="px-5 pb-5 text-gray-400 leading-relaxed text-sm md:text-base">
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
};

const FAQ: React.FC = () => {
  const faqs = [
    {
      question: "What exactly do I get?",
      answer: "You get the complete source code for a production-ready joinlist boilerplate, including all API routes, Prisma schema, React components, Supabase integration, and image prompts. Everything is TypeScript and ready to customize. Launch your joinlist in 10 minutes, not weeks.",
    },
    {
      question: "Can I get a refund?",
      answer: "No. This is digital code delivered instantly. All sales are final. Make sure this is what you need before purchasing.",
    },
    {
      question: "Is this just a PDF or actual code?",
      answer: "This is the actual source code—a complete Next.js application with all files, components, and database schema. You'll receive a download link via email immediately after purchase.",
    },
    {
      question: "Do I need PeerQuik to use this?",
      answer: "No. This code works standalone. However, it's designed to integrate seamlessly if you're using the PeerQuik boilerplate. You can also adapt it to any Next.js project.",
    },
    {
      question: "What tech stack does it use?",
      answer: "Next.js 14 (App Router), TypeScript, Prisma (PostgreSQL), Supabase (auth and storage), and Tailwind CSS. You'll need basic knowledge of these to customize it for your project.",
    },
    {
      question: "What are the image prompts?",
      answer: "The boilerplate includes ready-to-use prompts that you can use with AI image generators to create stunning visuals for your joinlist. These prompts are designed to help you create professional-looking images quickly.",
    },
    {
      question: "Will you help me implement this?",
      answer: "This is self-service code. The boilerplate includes comments and clear structure, but no implementation support is provided. If you need help, consider hiring a developer or checking the PeerQuik community.",
    },
    {
      question: "Can I use this for client projects?",
      answer: "Yes. Once purchased, you can use this code in unlimited projects—commercial or personal. You cannot resell or redistribute the code itself.",
    },
    {
      question: "How long does it take to set up?",
      answer: "With this boilerplate, you can have your joinlist up and running in about 10 minutes. The setup process is straightforward and well-documented. No complex configuration needed.",
    },

    {
      question: "Do I have to use Supabase?",
      answer: "No. While the boilerplate is optimized for Supabase, it uses Prisma ORM. This means you can use ANY database (PostgreSQL, MySQL, MongoDB, Neon, or Railway) by just changing the connection string in your .env file.",
    },
  ];

  return (
    <section className="bg-[#050505] text-white py-24 px-4 relative overflow-hidden">
      <div className="max-w-3xl mx-auto relative z-10">
        <div className="flex flex-col items-center mb-12">
          <HelpCircle className="text-cyan-400 mb-4" size={32} />
          <h2 className="text-4xl md:text-5xl font-black text-center tracking-tight">
            Common Questions
          </h2>
        </div>

        <div className="mt-8">
          {faqs.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>

        <p className="text-center text-gray-500 mt-12 text-sm">
          Still have questions? Send me a DM and I'll help you out.
        </p>
      </div>
    </section>
  );
};

export default FAQ;

// "use client";

// import { useState } from "react";
// import { ChevronDown, ChevronUp } from "lucide-react";

// interface FAQItemProps {
//   question: string;
//   answer: string;
// }

// const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <div className="border border-gray-800 rounded-lg overflow-hidden">
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className="w-full flex items-center justify-between p-5 text-left hover:bg-gray-900 transition-colors"
//       >
//         <span className="font-semibold text-white">{question}</span>
//         {isOpen ? (
//           <ChevronUp className="text-cyan-400 flex-shrink-0" size={20} />
//         ) : (
//           <ChevronDown className="text-cyan-400 flex-shrink-0" size={20} />
//         )}
//       </button>
//       {isOpen && (
//         <div className="px-5 pb-5 text-gray-300">
//           <p>{answer}</p>
//         </div>
//       )}
//     </div>
//   );
// };

// const FAQ: React.FC = () => {
//   const faqs = [
//     {
//       question: "What exactly do I get?",
//       answer: "You get the complete source code for a production-ready joinlist boilerplate, including all API routes, Prisma schema, React components, Supabase integration, and image prompts. Everything is TypeScript and ready to customize. Launch your joinlist in 10 minutes, not weeks.",
//     },
//     {
//       question: "Can I get a refund?",
//       answer: "No. This is digital code delivered instantly. All sales are final. Make sure this is what you need before purchasing.",
//     },
//     {
//       question: "Is this just a PDF or actual code?",
//       answer: "This is the actual source code—a complete Next.js application with all files, components, and database schema. You'll receive a download link via email immediately after purchase.",
//     },
//     {
//       question: "Do I need PeerQuik to use this?",
//       answer: "No. This code works standalone. However, it's designed to integrate seamlessly if you're using the PeerQuik boilerplate. You can also adapt it to any Next.js project.",
//     },
//     {
//       question: "What tech stack does it use?",
//       answer: "Next.js 14 (App Router), TypeScript, Prisma (PostgreSQL), Supabase (auth and storage), and Tailwind CSS. You'll need basic knowledge of these to customize it for your project.",
//     },
//     {
//       question: "What are the image prompts?",
//       answer: "The boilerplate includes ready-to-use prompts that you can use with AI image generators to create stunning visuals for your joinlist. These prompts are designed to help you create professional-looking images quickly.",
//     },
//     {
//       question: "Will you help me implement this?",
//       answer: "This is self-service code. The boilerplate includes comments and clear structure, but no implementation support is provided. If you need help, consider hiring a developer or checking the PeerQuik community.",
//     },
//     {
//       question: "Can I use this for client projects?",
//       answer: "Yes. Once purchased, you can use this code in unlimited projects—commercial or personal. You cannot resell or redistribute the code itself.",
//     },
//     {
//       question: "How long does it take to set up?",
//       answer: "With this boilerplate, you can have your joinlist up and running in about 10 minutes. The setup process is straightforward and well-documented. No complex configuration needed.",
//     },
//   ];

//   return (
//     <section className="bg-black text-white py-16 px-4">
//       <div className="max-w-3xl mx-auto">
//         <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center">
//           Frequently Asked Questions
//         </h2>

//         <div className="space-y-4">
//           {faqs.map((faq, index) => (
//             <FAQItem key={index} question={faq.question} answer={faq.answer} />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FAQ;
